module.exports = __webpack_public_path__ + "img/33.2.TN.d52b1160.png";